// extracted by mini-css-extract-plugin
export default {"left_box":"LeftBox_left_box__B8g6A"};